import { Pet, PetLight } from "src/app/backend/models/pet/pet";
import { dateUtil } from "src/app/support/date-util";
import { last } from "lodash-es";
import { formatWeight } from "src/app/support/weight";

export function patientExtend(patient: Pet): Pet {
  return <Pet>_patientExtend(patient);
}

export function patientLightExtend(patient: PetLight): PetLight {
  return <PetLight>_patientExtend(patient);
}

function _patientExtend(patient: Pet | PetLight): Pet | PetLight {
  const sortedWeighing = patient.weighing?.sort((left, right) => {
    return dateUtil(left.createdAt).isBefore(dateUtil(right.createdAt))
      ? -1
      : 1;
  });

  const lastWeight =
    sortedWeighing && sortedWeighing.length > 0
      ? last(sortedWeighing)?.weight
      : undefined;

  const lastWeightDisplay = lastWeight ? formatWeight(lastWeight) : undefined;

  return {
    ...patient,
    weighing: sortedWeighing,
    lastWeight,
    lastWeightDisplay
  };
}
